/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchGetOwnerForMerchant} from '../api'

export const useMutationBatchGetOwnerForMerchant = createReactQueryMutationHook('batchGetOwnerForMerchant', batchGetOwnerForMerchant)
